export const mustBeInFuture = (d: (Date | null) = new Date()): boolean => {
  const now = new Date();
  return d > now;
}

export const mustBeInPast = (d: (Date | null) = new Date()): boolean => {
  const now = new Date();
  return d < now;
}
